module.exports = __webpack_public_path__ + "static/img/logo_u_galileo.c0d5fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_u_galileo.png
// module id = JVod
// module chunks = 1